import { createContext, useContext } from "react";

export const SettingsPresentationContext = createContext<
  "legacy" | "redesigned"
>("legacy");

export function useSettingsPresentation(): "legacy" | "redesigned" {
  return useContext(SettingsPresentationContext);
}
